  <!-- recibe-nuestras-promociones.php -->
  <div class="bk-newsletter-area bg_image--13 ptb--150 ptb-lg--100 ptb-md--80 ptb-sm--80">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
                <!-- Start Newsletter Area -->
                <div class="contact-form bg_color--1 contact-form--2 wow move-up">
                    <h4 class="heading heading-h4">Recibe nuestras promociones</h4>
                    <form action="#">
                        <div class="row">

                            <div class="col-lg-12">
                                <input type="text" placeholder="Tu nombre">
                            </div>

                            <div class="col-lg-12 mt--30">
                                <input type="email" placeholder="Tu e-mail">
                            </div>

                            <div class="col-lg-12">
                                <div class="form-desc "> Nuevos cursos y nuevos productos.</div>
                            </div>
                            <div class="col-lg-12 mt--30">
                                <div class="submit-btn">
                                    <a class="brook-btn bk-btn-theme with-no-shadow btn-sd-size btn-bullet space-between"
                                        href="#">Suscribirme</a>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- End Newsletter Area -->
            </div>
        </div>
    </div>
</div>

